import Header from "@Components/Header/Header"
import { MobHeader } from "@Components/Mob-header/Mob-header"
import { SubscriptionRequestInstituteForm } from "@Src/features/SubscriptionRequestInstituteForm/SubscriptionRequestInstituteForm"
import HomeLayout from "@Src/features/layout/components/HomeLayout/HomeLayout"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


export const SubscriptionRequestInstitute =() => {

    return (
        <>
        {/* <GoogleReCaptchaProvider reCaptchaKey="6Lekey4sAAAAAOFo9Q2pmItF4-uHbbqRepQEKp5D"> */}
            <HomeLayout>            
                <SubscriptionRequestInstituteForm/>            
            </HomeLayout>
        {/* </GoogleReCaptchaProvider> */}
        </>
    )
}